import { Sheet } from '@hover/blueprint';
import React from 'react';

import { useProPageContext } from '../../hooks/useProPageContext';
import { ProPageSheetSteps } from '../../providers/ProPageProvider';

import { CreateAccountSheet } from './CreateAccountSheet';
import { FoundAccountSheet } from './FoundAccountSheet';
import { LeadSheet } from './LeadSheet';

interface ProPageSheetProps {
  isOpen: boolean;
  onClose: () => void;
  photoUploadSheetOnOpen: () => void;
}

export const ProPageSheet = ({
  isOpen,
  onClose,
  photoUploadSheetOnOpen,
}: ProPageSheetProps) => {
  const { proPageSheetStep } = useProPageContext();
  return (
    <>
      <Sheet.Container
        autoFocus={false}
        isOpen={isOpen}
        onClose={onClose}
        size="full"
      >
        {proPageSheetStep === ProPageSheetSteps.LEAD && (
          <LeadSheet
            onClose={onClose}
            photoUploadSheetOnOpen={photoUploadSheetOnOpen}
          />
        )}
        {proPageSheetStep === ProPageSheetSteps.CREATE_ACCOUNT && (
          <CreateAccountSheet
            onClose={onClose}
            photoUploadSheetOnOpen={photoUploadSheetOnOpen}
          />
        )}
        {proPageSheetStep === ProPageSheetSteps.FOUND_ACCOUNT && (
          <FoundAccountSheet />
        )}
      </Sheet.Container>
    </>
  );
};
